import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { css } from "@emotion/react";
import { FormattedMessage } from "react-intl";
import { useMissionRoleApplicant } from "hooks";
import { PrimaryButton } from "components/Buttons";

/**
 * Candidate Submit Button
 *
 * @param {Object}  missionRoleApplicant
 * @param {Boolean} canSubmit
 * @param {Array}   completedSteps
 * @param {Boolean}  hasPreferredRate
 */
const ApplicationSubmitButton = ({ missionRoleApplicant, canSubmit, completedSteps, hasPreferredRate, ...props }) => {
  const { data, submitApplication, submitting } = useMissionRoleApplicant({ id: missionRoleApplicant?.id });

  const handleSubmit = () => {
    const checklistStepNames = data?.applicationChecklist?.map(({ name }) => name.toUpperCase()) || [];
    const applicableSteps = data?.missionRole?.applicationSteps?.filter(({ name }) =>
      checklistStepNames.includes(name)
    );

    submitApplication(data?.id, applicableSteps, completedSteps, hasPreferredRate);
  };

  return (
    <PrimaryButton
      disabled={!canSubmit || submitting}
      variant="green"
      css={styles.button}
      onClick={handleSubmit}
      {...props}
    >
      {data?.appliedAt ? (
        <FormattedMessage
          id="Missions.Applicants.ApplicationSubmitButton.Submitted"
          values={{
            date: moment(data?.appliedAt).format("MMMM Do, YYYY"),
          }}
        />
      ) : (
        <FormattedMessage id="Missions.Applicants.ApplicationSubmitButton.CTA" />
      )}
    </PrimaryButton>
  );
};

const styles = {
  button: css`
    width: 100%;
  `,
};

ApplicationSubmitButton.propTypes = {
  missionRoleApplicant: PropTypes.object.isRequired,
  canSubmit: PropTypes.bool.isRequired,
  completedSteps: PropTypes.array.isRequired,
  hasPreferredRate: PropTypes.bool.isRequired,
};

export default ApplicationSubmitButton;
